import { ReactComponent as SubscriptionRevenueIcon } from 'assets/SubscriptionRevenueIcon.svg';
import Button from 'components/Buttons/Button';
import {
  balanceCardButtonClassName,
  formatCurrencyAmount,
  subscriptionRevenueCardBodyClassName,
  subscriptionRevenueCardClassName,
  subscriptionRevenueCardDividerClassName,
  subscriptionRevenueCardFooterClassName,
} from 'components/Home/balanceCardSurface';
import { routes } from 'constants/routes';
import { useNavigate } from 'react-router-dom';

export interface SubscriptionBalanceData {
  balance: number;
  period: string;
  payoutDate: string;
  totalPlatformFee: number;
}

interface SubscriptionBalanceTileProps {
  data: SubscriptionBalanceData;
}

const SubscriptionBalanceTile: React.FC<SubscriptionBalanceTileProps> = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div className={subscriptionRevenueCardClassName}>
      <div className={subscriptionRevenueCardBodyClassName}>
        <div className="grid min-h-0 flex-1 grid-cols-[1fr_auto] grid-rows-[auto_1fr] gap-x-4">
          <div className="mt-3 flex flex-col gap-2">
            <div className="font-poppins text-2xl font-semibold leading-none text-white">
              Subscription Revenue
            </div>
            <div className="font-poppins text-base font-medium leading-none text-greyText">
              For {data.period}
            </div>
          </div>
          <div className="row-span-2 flex items-center">
            <Button
              label="Subscription History"
              type="button"
              variant="secondary"
              customClass={balanceCardButtonClassName}
              onClick={() => navigate(routes.subscriptionHistory)}
            />
          </div>
          <div className="flex items-center gap-2 self-end">
            <SubscriptionRevenueIcon className="h-10 w-10 shrink-0" />
            <span className="font-poppins text-[40px] font-bold leading-none text-white">
              ${formatCurrencyAmount(data.balance)}
            </span>
          </div>
        </div>
      </div>
      <div className={subscriptionRevenueCardDividerClassName} aria-hidden="true" />
      <div className={subscriptionRevenueCardFooterClassName}>
        <p className="font-poppins text-sm leading-none">
          <span className="text-navyDark">
            Processing fee – ${formatCurrencyAmount(data.totalPlatformFee)}
          </span>
          <span className="text-greyText"> • </span>
          <span className="text-greyText">Payout Date – {data.payoutDate}</span>
        </p>
      </div>
    </div>
  );
};

export default SubscriptionBalanceTile;
